import React, {Component} from 'react';
import marketStyle from '../css/marketsSoccer3.css';
import OddsCardSoccer3 from './oddsCardSoccer3';

class TotalGoalsSoccer3 extends Component {
    render() {
        let markets = this.props.markets;
        let store = this.props.store;

        let marketsCount = markets.length;
        let reminder = marketsCount % 3;

        let totalGoalsMarkets = markets.map((market, index) => {
            return (
                <div className={marketStyle.scoreGroupSmall} key={index}>
                    <div className={`${marketStyle.marketLabelSmall} ${marketStyle.marketLabel}`}>
                        <span>{market.selection}</span>
                    </div>
                    <div className={marketStyle.oddsContainerSmall}>
                        <OddsCardSoccer3 store={store} market={market}/>
                    </div>
                </div>
            );
        });

        for (var i = 0; i < (3 - reminder) && reminder != 0; i++) {
            totalGoalsMarkets.push(<div className={marketStyle.scoreGroupSmall} key={marketsCount++}></div>)
        }


        return (<div className={`${marketStyle.marketGroup} ${marketStyle.marketAlignFlex}`}>{totalGoalsMarkets}</div>);
    }
}

export default TotalGoalsSoccer3;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/football/components/totalGoalsSoccer3.js